import { isNexusAgent } from '../../features/utils/AgentUtils';
import { Agent, NexusAgent } from '../agents/models/Agent';
import { ChatProviderType } from '../chat/models/ChatProviderType';
import { ChatSession } from '../chat/models/ChatSession';

// for assistants, we need to find the oldAssistantId (old customGPTId property) in the agent metadata since that's how we're mapping old assistants gpts to new nexus agents for displaying in the UI.
// for example: if the chat session is an old RFI chat, and RFI assistants gpt had id: abc123, then Nexus RFI will have a metadata field oldAssistantId with value abc123, and we can use that to link the session to the correct agent and display the correct name and avatar in the UI
const findNexusAgentByAssistantId = (agentsById: Record<string, Agent>, assistantId: string): NexusAgent | null => {
    for (const agent of Object.values(agentsById)) {
        if (isNexusAgent(agent) && agent.oldAssistantId === assistantId) {
            return agent;
        }
    }

    return null;
};


export const resolveSessionAgent = (session: ChatSession, agentsById: Record<string, Agent>): Agent | null => {
    if (session.providerType === ChatProviderType.ProGPT) {
        return agentsById[session.agentId] ?? null;
    }

    if (session.providerType === ChatProviderType.Nexus) {
        return agentsById[session.agentId] ?? null;
    }

    // Assistants sessions are linked through historical assistantId/customGPTId.
    return findNexusAgentByAssistantId(agentsById, session.agentId);
};
